"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.elementId = exports.queryAll = void 0;
function queryAll(selector) {
    return Array.from(document.querySelectorAll(selector));
}
exports.queryAll = queryAll;
function elementId(id) {
    return document.getElementById(id);
}
exports.elementId = elementId;
